import type { ReactNode } from 'react';

export type PageHeaderProps = {
  title: ReactNode;
  description?: ReactNode;
  right?: ReactNode;
};

export function PageHeader({ title, description, right }: PageHeaderProps) {
  return (
    <div className="flex items-start justify-between gap-4">
      <div className="min-w-0">
        <h1 className="text-3xl font-bold tracking-tight">{title}</h1>
        {description ? <div className="text-muted-foreground mt-1">{description}</div> : null}
      </div>

      {right ? <div className="shrink-0">{right}</div> : null}
    </div>
  );
}
